var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSonicLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4380.1846 2308.3643",
    height: 2308.3643,
    width: 4380.1846,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,-0.44122758,2308.9164)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.01595)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "transparent",
      stroke: "none"
    },
    d: "m 16019.6,7312.5 c 324.8,569.79 -205.1,1247.84 -837.6,1065.51 L 7125.18,6070.36 1905.9,7563.2 C 1404.46,7705.65 948.624,7232.73 1108.17,6737.01 L 1814.71,4571.8 c 85.47,-262.11 56.98,-552.7 -85.46,-792.03 L 270.576,1244.22 C -20.0161,737.111 447.213,133.12 1011.31,292.666 L 7455.65,2138.78 14179.2,212.892 c 564.1,-159.546 1076.9,370.366 894.6,928.748 l -809.1,2490 c -85.5,262.09 -51.3,546.99 85.4,786.31 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.01595)",
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14384.3,2.05393 c -85.4,0 -170.9,11.39547 -256.4,39.89667 L 7455.65,1950.75 1056.9,116.03 C 732.11,19.1423 384.533,133.12 173.714,406.622 -31.4096,668.712 -54.1986,1039.08 111.029,1335.38 L 1575.41,3870.96 c 113.95,193.71 136.74,427.34 68.37,643.85 L 937.23,6680.02 c -96.862,296.32 -22.783,615.37 188.04,837.6 216.51,222.21 535.6,307.68 831.9,222.21 L 7125.18,6258.39 15136.5,8554.64 c 353.2,102.56 740.7,-22.79 968.6,-319.09 227.9,-290.59 256.4,-695.14 68.4,-1014.22 L 14504,4326.78 c -108.3,-193.73 -136.7,-427.33 -62.7,-638.17 l 803.4,-2489.98 c 91.2,-279.203 39.9,-581.209 -125.3,-814.795 C 14948.4,144.513 14674.9,7.76812 14384.3,2.05393 Z M 7455.65,2326.81 l 51.3,-11.39 6723.55,-1925.892 c 193.7,-56.985 404.5,0 547,142.44 136.8,148.133 188,358.971 125.3,552.702 l -809.1,2489.99 c -96.8,313.38 -62.6,649.56 96.9,934.46 l 1669.5,2894.55 c 114,193.73 96.9,433.03 -39.9,609.67 -142.4,176.64 -370.4,256.41 -586.9,193.72 L 7125.18,5882.33 1854.6,7392.27 c -165.24,45.58 -347.57,0 -467.23,-125.36 -119.65,-125.35 -159.55,-307.69 -108.26,-472.93 l 706.54,-2170.91 c 102.56,-307.68 62.68,-649.57 -96.86,-934.46 L 424.426,1153.03 C 327.563,987.807 344.652,776.969 458.608,628.834 578.257,475.003 777.682,412.317 960.019,463.588 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 12928.2,11008.4 C 11411.9,11008.4 9964.61,9756.41 9711.88,8217.19 9447.7,6677.93 10470,5425.9 11997.7,5425.9 c 1516.3,0 2963.6,1252.03 3216.4,2791.29 264.1,1539.22 -758.2,2791.21 -2285.9,2791.21 z m -746.7,-4456.8 c -781.1,0 -1298,746.6 -1137.2,1665.59 160.9,918.9 919,1665.58 1700.1,1665.58 781.1,0 1298,-746.68 1137.2,-1665.58 -160.9,-918.99 -919,-1665.59 -1700.1,-1665.59 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 8597.7,8504.34 6909.14,9549.61 c -22.97,23.01 -34.49,57.46 -34.49,91.91 0,68.95 57.46,126.33 137.85,126.33 l 2193.98,-0.12 643.25,1125.87 -2883.17,-0.2 c -712.18,0.2 -1343.94,-585.7 -1389.88,-1297.81 -45.98,-459.5 183.75,-895.98 585.78,-1137.19 L 7874.02,7378.63 c 103.36,-68.94 160.82,-183.75 149.3,-310.11 -11.48,-183.79 -160.78,-333.13 -344.57,-356.14 0,0 -22.97,0 -34.49,0 l -2768.28,-0.11 -666.25,-1171.53 3400.07,-0.12 c 873.01,0.12 1631.14,712.31 1700.04,1585.32 45.94,562.85 -229.72,1102.73 -712.14,1378.4 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.41962)",
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14746.4,3902.96 930.6,-0.08 623,3770.69 -930.5,-0.1 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.71137)",
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15951,3553.06 c -288.6,-255.04 -664.5,-382.57 -1067.2,-382.57 -966.6,0 -1470,684.62 -1315.6,1644.43 167.8,1000.08 993.4,1617.6 1912.9,1617.6 328.9,0 637.7,-80.53 818.9,-248.34 l -355.7,-610.81 c -127.6,140.97 -322.2,201.39 -563.8,201.39 -490,0 -953.1,-375.89 -1047.1,-939.69 -100.7,-597.38 194.6,-1000.09 738.3,-1000.09 228.2,0 510.1,87.24 698,295.34 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.297)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14865.3,5742.14 -1169,2435.48 c -70.9,132.85 -203.8,221.42 -345.5,221.42 l -867.9,-0.12 -690.8,-4126.97 1000.8,-0.09 425.1,2603.87 1098.2,-2267.21 c 168.3,-363.13 460.5,-425.11 708.5,-425.11 425.1,0 619.9,230.25 690.8,717.34 l 584.5,3498.29 -1000.8,-0.12 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicLogo);
export default __webpack_public_path__ + "static/media/sonic-logo.86c487db72fda3fa2bcf2042fe950a3e.svg";
export { ForwardRef as ReactComponent };